// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] || chunkId) + "-" + {"231":"f35bb6126f9e2eb383c1","589":"3ce81b5edbc38d104b36","610":"2b9cdd285285e5beef2a","678":"446278451900c2a079f1","883":"73f1ddc6a90239afaeae","898":"af3e22f978bf3cf5ad41"}[chunkId] + ".js";
};